/**
 * /library/wiki/new — redirect to the documents workspace with the
 * "new article" action pre-fired.
 *
 * #223 — the documented IA exposes `/library/wiki/new` as the
 * "create wiki article" entry point, but article authoring is
 * embedded inside `/library/documents` and triggered via
 * `?action=article` (see DocumentsPage useEffect that consumes
 * `actionFromUrl`). Sending users here keeps the bookmark working
 * and triggers the same New-Article flow.
 *
 * #236 (round 6 reopen) — the round-3 implementation used a
 * component-based `<Navigate to=... search={{action:'article'}}>`.
 * That fires AFTER the destination route mounts, so when
 * `documents.tsx` renders and reads `window.location.search`, the
 * URL is still `/library/documents` with no query string. The
 * action handler never sees `action=article` and the editor
 * doesn't open. Round 5 added `validateSearch` on the destination
 * route hoping the param would survive — round-6 retest confirmed
 * it still doesn't work end-to-end.
 *
 * Switch to TanStack Router's `beforeLoad` + `throw redirect()`
 * pattern (same shape as routes/models.tsx and the sysadmin
 * index redirects). `beforeLoad` runs during route resolution,
 * BEFORE the destination component mounts.
 *
 * #1337 — live ai1 proved that `{ to, search }` can still land on
 * `/library/documents` without the article action opening the editor
 * even though source tests passed. Use raw `href` so the browser URL
 * is already `/library/documents?action=article` before the documents
 * route reads its validated search params.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/library/wiki/new')({
  beforeLoad: () => {
    if (typeof window !== 'undefined') {
      try {
        window.sessionStorage.setItem('argusai.library.pendingNewArticle', '1');
      } catch {
        // Hardened browser policies can block storage; the URL action still carries intent.
      }
    }
    throw redirect({
      href: '/library/documents?action=article',
      replace: true,
    });
  },
});
